// extracted by mini-css-extract-plugin
export var cBar = "styles-module--c-bar--8cc0d";
export var cBarContent = "styles-module--c-bar-content--8736c";
export var cBarIcon = "styles-module--c-bar-icon--602e2";
export var cBarLink = "styles-module--c-bar-link--d06e3";
export var cBarTel = "styles-module--c-bar-tel--171e0";